import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, PanelGroup } from 'react-bootstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';
import JobTask from './JobTask.react';
import JobTaskSpec from '../../stores/specs/JobTaskSpec';

const JobTasks = ({ jobTasks, activeTask, updateTask, removeTask, setActiveTask, readOnly }) => (
  <FormGroup>
    <PanelGroup>
      {
        jobTasks.map((task, index) =>
          <JobTask
            key={index}
            task={task}
            active={index === activeTask}
            taskIndex={index}
            updateTask={updateTask}
            removeTask={removeTask}
            setActiveTask={setActiveTask}
            readOnly={readOnly}
          />)
      }
    </PanelGroup>
  </FormGroup>
);

export default JobTasks;

JobTasks.propTypes = {
  jobTasks: ImmutablePropTypes.listOf(PropTypes.instanceOf(JobTaskSpec)),
  updateTask: PropTypes.func,
  activeTask: PropTypes.number,
  setActiveTask: PropTypes.func,
  removeTask: PropTypes.func,
  readOnly: PropTypes.bool,
};
